import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import fr from './locales/fr.json';
import en from './locales/en.json';
import es from './locales/es.json';
import ru from './locales/ru.json';

const resources = {
  fr: { translation: fr },
  en: { translation: en },
  es: { translation: es },
  ru: { translation: ru },
};

const supportedLanguages = ['fr', 'en', 'es', 'ru'];

/**
 * Detect the user's preferred language.
 * Priority: localStorage > browser language > default (fr)
 */
function detectLanguage(): string {
  // 1. Check localStorage for a previously saved preference
  const stored = localStorage.getItem('lang');
  if (stored && supportedLanguages.includes(stored)) {
    return stored;
  }

  // 2. Check browser language (navigator.language or navigator.languages)
  if (typeof navigator !== 'undefined') {
    const browserLanguages = navigator.languages
      ? Array.from(navigator.languages)
      : [navigator.language];

    for (const lang of browserLanguages) {
      const shortLang = lang.split('-')[0].toLowerCase();
      if (supportedLanguages.includes(shortLang)) {
        return shortLang;
      }
    }
  }

  // 3. Default to French
  return 'fr';
}

i18n.use(initReactI18next).init({
  resources,
  lng: detectLanguage(),
  fallbackLng: 'fr',
  supportedLngs: supportedLanguages,
  interpolation: {
    escapeValue: false,
  },
});

// Persist language changes to localStorage
i18n.on('languageChanged', (lng: string) => {
  localStorage.setItem('lang', lng);
  document.documentElement.lang = lng;
});

export default i18n;
